import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import './SurveyContainer.scss';

type SurveyContainerProps = {
  className?: string;
};

export const SurveyContainer: React.FC<PropsWithChildren<SurveyContainerProps>> = ({
  children,
  className,
}) => {
  return <div className={clsx('survey-container', className)}>{children}</div>;
};
